import { useQuery } from "@tanstack/react-query";
import { Link, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { spaceFromPath } from "./CommandPalette";
import { SpaceAvatar } from "./SpaceAvatar";

/**
 * Which space you are in, in the header, on every page inside one.
 *
 * A breadcrumb answers this only if you look up at it, and the content screen
 * in particular reads as "everything you own" without it.
 */
export function SpaceBadge() {
  const location = useLocation();
  const spaceId = spaceFromPath(location.pathname);

  const space = useQuery({
    queryKey: ["space", spaceId],
    queryFn: () => api.getSpace(spaceId as never),
    enabled: spaceId !== null,
  });

  if (!spaceId) return null;

  return (
    <>
      <span className="shell__sep" aria-hidden="true">
        /
      </span>
      <Link to={`/spaces/${spaceId}`} className="shell__space">
        {space.data && <SpaceAvatar space={space.data} size={18} />}
        {space.data?.name ?? "…"}
      </Link>
    </>
  );
}
